import React from 'react'
const FooterLogo = () => {
  const footer_logo = {
    display: 'block',
  };
  return (
    <img src="/images/b-open-tennis-logo-green.png" title="Tennis" className="footer_logo" style={footer_logo} />
  )
}

export default FooterLogo